import { useGlobalState } from '@/context/GlobalStateProvider';
import { useHome } from '@/context/HomeContext';
import type { ClassItem } from '@/types/apiResponseTypes';
import { formatDate } from '@/utils/dateUtils';
import useClassScheduledList from '@/utils/getClassScheduledList';

import { Dialog, DialogContent, DialogHeader } from '../ui/dialog';

const FirstCourseMessageModal = () => {
  const { ProfileNameDetails } = useGlobalState();
  const { enrollmentData, termsData } = useHome();
  const {
    mvlClasssData,
    showClassRoomOpenModal,
    showClassRoomOpenModalChange,
    setShowClassRoomOpenModal,
  } = useClassScheduledList(enrollmentData, termsData?.Response?.StudentTerm);
  const { primaryName, preferedName } = ProfileNameDetails || {};

  return (
    <div>
      <Dialog
        open={showClassRoomOpenModal}
        onOpenChange={showClassRoomOpenModalChange}
        aria-label="Your Classroom is open"
      >
        <DialogContent
          size="lg"
          aria-label="edit grading dailog"
          className="flex max-h-[90vh] w-full flex-col border-none !p-0 sm1:!overflow-y-auto md:max-h-[90vh] md:w-2/3"
          dailogCloseClassName="top-12 sm1:top-10 opacity-100 text-base sm1:size-6 size-5 text-white"
          onInteractOutside={(e) => {
            e.preventDefault();
            setShowClassRoomOpenModal(false);
          }}
        >
          <DialogHeader className="bg-customRed p-8 text-left text-white">
            <div className="flex items-center justify-between font-sans">
              <h1 className="font-sans text-4xl font-normal text-white">
                Good News. Your Classroom is Open!
              </h1>
            </div>
            <p className="m-0 font-sans text-white">Set yourself up for success.</p>
          </DialogHeader>
          <section className="p-8 text-spblack">
            <p className="mb-2 font-sans">
              <span className="font-bold">{preferedName || primaryName}</span>, your online
              classroom(s) for the session beginning{' '}
              <span className="font-bold">
                {formatDate(mvlClasssData[0]?.START_DT, 'MMM dd, yyyy')}
              </span>{' '}
              is now open! Get a head start in your course(s) by participating today...
            </p>
            <ul className="list-inside !list-disc space-y-2 p-0">
              <li className="flex items-baseline font-sans font-semibold">
                <span className="mr-1 inline-block size-[7px] min-h-[7px] min-w-[7px] rounded-full border-[3px] border-solid border-black bg-white"></span>
                Log in and familiarize yourself with the classroom
              </li>
              <li className="flex items-baseline font-sans font-semibold">
                <span className="mr-1 inline-block size-[7px] min-h-[7px] min-w-[7px] rounded-full border-[3px] border-solid border-black bg-white"></span>
                Review your syllabus and start on your first assignment
              </li>
              <li className="flex items-baseline font-sans font-semibold">
                <span className="mr-1 inline-block size-[7px] min-h-[7px] min-w-[7px] rounded-full border-[3px] border-solid border-black bg-white"></span>
                Customize notification settings
              </li>
              <li className="flex items-baseline font-sans font-semibold">
                <span className="mr-1 inline-block size-[7px] min-h-[7px] min-w-[7px] rounded-full border-[3px] border-solid border-black bg-white"></span>
                Introduce yourself to your instructors and classmates
              </li>
            </ul>
            <p className="my-5">It&apos;s going to be a great session. You got this!</p>

            <ul className="mb-8 list-none p-0">
              {mvlClasssData.map((classItem: ClassItem, index: number) => (
                <li
                  key={index}
                  className="m-0 flex flex-col items-center justify-between border-0 border-y border-solid border-spgray py-4 sm1:flex-row"
                  ng-repeat="class in termItem.Class"
                >
                  <div className="flex items-center">
                    <span className="mr-3 hidden size-[8px] min-h-[8px] min-w-[8px] rounded-full border-4 border-solid border-black bg-white sm1:inline-block"></span>
                    <span className="mb-3 text-center font-sans text-lg font-bold text-spblack sm1:mb-0 sm1:text-left">
                      {classItem?.SUBJECT} {classItem?.CATALOG_NBR} {classItem.COURSE_TITLE_LONG}
                    </span>
                  </div>
                  <button
                    data-testid="first-course-modal-go-to-classroom-button"
                    className="border-none bg-primary px-4 py-2 font-sans font-bold"
                    onClick={() => window.open(classItem.LMS_CRSEOFFERING.classLink)}
                  >
                    Go to Classroom
                  </button>
                </li>
              ))}
            </ul>

            <div className="flex justify-center">
              <button
                data-testid="first-course-modal-remind-me-again-button"
                className="border border-solid border-primary bg-white px-4 py-2 font-sans font-bold"
                onClick={() => showClassRoomOpenModalChange()}
              >
                Remind Me Again
              </button>
            </div>
          </section>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FirstCourseMessageModal;
